module.exports = __webpack_public_path__ + "static/media/12_l_holst_0.99_64.35.735053e0.png";